<template>
	<vs-dialog prevent-close v-model="active" @close="borrarInfo">
		<template #header>
			<h4 class="not-margin">
				Registrar pago {{ tipo && tipo == 'abierto' ? 'abierto' : tipo == 'cargo-abono' ? 'desde regla de cobro' : tipo == 'servicio' ? 'desde servicio' : '' }}
			</h4>
		</template>


		<div class="con-form">
			<template v-for="(ciclo, c) in cicloEscolares">
				<h5 :key="c" v-if="ciclo.id == cicloEscolar">Ciclo escolar: <strong>{{ciclo.text}}</strong></h5>
			</template>
			<vs-row>
				<vs-col vs-justify="center" vs-align="center" xs="12" lg="6">
					<label for="fecha" class="labelInput">
						Fecha 
					</label>
					<vs-input
					:disabled="bloquear == true"
					class="pt-0"
					type="date"
					v-model="fecha"
					required="required"
					id="fecha"
					name="fecha"
					@change="getConcepto()">
						<template #message-danger v-if="errorFields.includes('fecha')">
							Requerido
						</template>
					</vs-input>
				</vs-col>
				<vs-col v-if="tipo !== 'servicio'" vs-justify="center" vs-align="center"  xs="12" lg="6">
						<!-- @input="roundDecimals('monto')" -->
					<form autocomplete="off" >
						<label for="monto" class="labelInput">
							Monto
						</label>
						<vs-input
						class="pt-0"
						type="number"
						v-model="monto"
						required="required"
						id="monto"
						name="monto">
							<template #message-danger v-if="errorFields.includes('monto')">
								Requerido
							</template>
						</vs-input>
					</form>
					
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col class="mt-3" vs-justify="center" vs-align="center" xs="12" lg="12">
					<vs-select :filter="Boolean(programas.length > 1)" label-placeholder="Programa" v-model="programa" :key="programaId" :disabled="!Boolean(programas.length > 1)" ref="content" @change="getConcepto()" >

						<template #message-danger v-if="errorFields.includes('programa')">
							Requerido
						</template>
						<template v-if="programas.length">
							<vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
								{{option.text}}
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" :value="0">
								No hay datos
							</vs-option>
						</template>
					</vs-select>
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col vs-justify="center" vs-align="center" w="12">
					<form autocomplete="off">
						<label for="fecha" class="labelInput">
							No. de autorización
						</label>
						<vs-input
						:disabled="bloquear == true"
						class="pt-0"
						v-model="autorizacion"
						required="required"
						id="fecha"
						name="fecha">
							<template #message-danger v-if="errorFields.includes('autorizacion')">
								Requerido
							</template>
						</vs-input>
					</form>
				</vs-col>
			</vs-row>
			<vs-row>
				<form autocomplete="off" style="width:100%;">
					<vs-select id="metodo-pago-registro-pago" class="marginTop" filter label-placeholder="Método de pago"  
						v-model="metodoPago"  :key="metodoPagoId" :disabled="!listMetodoPago.length || bloquear == true">
						<template #message-danger v-if="errorFields.includes('metodoPago')">
							Requerido
						</template>
						<template v-if="listMetodoPago.length">
							<vs-option v-for="option in listMetodoPago" :key="option.id"  :label="option.text" :value="option.id">
								{{option.text}}
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" :value="0">
								No hay datos
							</vs-option>
						</template>
					</vs-select>
				</form>
			</vs-row>
			<vs-row>
				
				<div class="vs-select-content vs-component--primary">
					<label for="2515" class="labelInput">Concepto</label>
					<div v-show="!isDropdownOpen" class="vs-select vs-select--state-null" @click="toggleDropdown">
						<input v-model="conceptoName" @focus="showSearch" id="2515" class="vs-select__input" :disabled="!listConceptos.length">
						<div v-if="loadingConcepto" class="spinner-overlay">
							<div class="spinner"></div>
						</div>
						<i v-else class="vs-icon-arrow"></i>
					</div>
					<div class="vs-input__message vs-input__message--danger v-enter-to" v-if="errorFields.includes('concepto') || noConceptos">
						{{ errorFields.includes('concepto') ? 'Requerido' : noConceptos == true ? 'Para este Ciclo escolar no hay reglas de cobro configuradas' : ''}}
					</div>
					<div class="vs-select vs-select--state-null activeOptions margenShadow" v-show="isDropdownOpen">
						<input
						 	@blur="ocultarDiv()"
							ref="searchConceptos"
							type="text"
							v-model="searchTerm"
							placeholder="Buscar conceptos"
							class="search-input"
							@click.stop
						/>
					</div>
					<div class="vs-select vs-select--state-null vs-select__options" v-show="isDropdownOpen">
						<div style="width: 100%;" class="vs-select__options__content"> 
							<div v-for="(option, index) in filteredOptions" :key="index"  class="vs-select__option" @click="selectOption(option)">
								{{option.nombre}} <span v-if="tipo != 'abierto'">- $ {{option.monto_cargo}}</span> <span v-if="option.subcategoria_servicio">({{option.subcategoria_servicio}})</span>
							</div>
						</div>
					</div>
				</div>
				<!-- <form autocomplete="off" style="width:100%;">
					<vs-select id="concpetos-registro-pago" class="mt-3" :loading="loadingConcepto" filter label-placeholder="Concepto" v-model="concepto"  :key="conceptoId" :disabled="!listConceptos.length">
						<template #message-danger v-if="errorFields.includes('concepto') || noConceptos">
							{{ errorFields.includes('concepto') ? 'Requerido' : noConceptos == true ? 'Para este Ciclo escolar no hay reglas de cobro configuradas' : ''}}
						</template>
						<template v-if="listConceptos.length">
							<vs-option v-for="option in listConceptos" :key="option.id" :label="option.subcategoria_servicio ? option.nombre + '(' + option.subcategoria_servicio + ')' : option.nombre " :value="option.id">
								{{option.nombre}} <span v-if="tipo != 'abierto'">- $ {{option.monto_cargo}}</span> <span v-if="option.subcategoria_servicio">({{option.subcategoria_servicio}})</span>
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" :value="0">
								No hay datos
							</vs-option>
						</template>
					</vs-select>
				</form> -->
			</vs-row>
			<vs-row v-if="tipo === 'servicio'">
				<vs-col vs-justify="center" vs-align="center"  xs="12" lg="12">
						<!-- @input="roundDecimals('monto')" -->
					<form autocomplete="off" >
						<label for="monto" class="labelInput">
							Monto
						</label>
						<vs-input
						class="pt-0"
						type="number"
						v-model="monto"
						required="required"
						id="monto"
						name="monto">
							<template #message-danger v-if="errorFields.includes('monto')">
								Requerido
							</template>
						</vs-input>
					</form>
					
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col xs="6" lg="3">
					<vs-switch id="switch-descuento" v-if="tipo === 'abierto'" style="margin: 14px 0px 0px 12px;" v-model="descuento">
						Descuento
					</vs-switch>
				</vs-col>
				<vs-col class="marginTop" vs-justify="center" vs-align="center"  xs="12" lg="8">
					<form autocomplete="off">
						<vs-select id="concpetos-descuentos-registro-pago" v-if="descuento" filter label-placeholder="Concepto Descuento" v-model="conceptoDescuento"  :key="conceptoDescuentoId" :disabled="!listDescuento.length">
							<template #message-danger v-if="errorFields.includes('conceptoDescuento')">
								Requerido
							</template>
							<template v-if="listDescuento.length">
								<vs-option v-for="option in listDescuento" :key="option.id"  :label="option.nombre" :value="option.id">
									{{option.nombre}}
								</vs-option>
							</template>
							<template v-else>
							<vs-option label="No hay datos" :value="0">
								No hay datos
							</vs-option>
							</template>
						</vs-select>
					</form>
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col v-if="descuento" vs-justify="center" vs-align="center" w="12">
					<form autocomplete="off">
						<label for="monto" class="labelInput">
							Monto 
						</label>
						<vs-input
						class="pt-0"
						type="number"
						v-model="montoDescuento"
						required="required"
						@input="roundDecimals('montoDescuento')"
						id="montoDescuento"
						name="montoDescuento">
							<template #message-danger v-if="errorFields.includes('montoDescuento')">
								Requerido
							</template>
						</vs-input>
					</form>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2 mb-2">
				<vs-button block class="color-blue" @click="encolarPagos">
					Agregar Pago  
				</vs-button>           
			</vs-row>
		</div>
		<template #footer>
			<div v-if="queuePagos.length" class="footer-dialog" style="max-width: 432px;">
				<vs-row class="mb-3">
					<vs-col>
						<h5>PAGOS</h5>
					</vs-col>
					<vs-col class="dividerLine" v-for="(pago, i) in queuePagos" :key="i">
						<vs-row class="mt-3" style="display: flex; justify-content: center; align-items: center;">
							<vs-col xs="12" lg="2" class="textRight">
								<i @click="removerPago(i)" class="fas fa-times dangerColor"></i>
							</vs-col>
							<vs-col xs="12" lg="10">
								<vs-row>
									<vs-col xs="12" lg="6">
										<div v-if="pago.concepto != ''" class="mb-3">
											<p class="mb-0 greyOscuro">{{pago.codigo_detalle_name}}</p>
											<small class="greyColor">Concepto</small>
										</div>
										<div v-if="pago.subcategoria != ''" class="mb-3">
											<p class="mb-0 greyOscuro">{{pago.subcategoria}}</p>
											<small class="greyColor">Subcategoría</small>
										</div>
										<div v-if="pago.fecha">
											<p class="greyOscuro mb-0 mt-3"><i class="far fa-calendar-alt mr-2"></i>{{pago.fecha}}</p>
											<small class="greyColor">Fecha</small>
										</div>
										<div v-if="pago.num_autorizacion">
											<p class="mb-0 mt-2 greyOscuro"><strong>{{pago.num_autorizacion}}</strong></p>
											<p class="mb-3"><small class="greyColor">No. de Autorización</small></p>
										</div>
										<div v-if="pago.metodo_de_pago != ''">
											<p class="mb-0 greyOscuro" style="overflow-wrap: break-word;">{{pago.metodo_pago_name}}</p>
											<p class="mb-3"><small class="greyColor">Método de pago</small></p>
										</div>
									</vs-col>
									<vs-col class="textRightDesktop" xs="12" lg="6">
										<div v-if="pago.monto">
											<h5 class="mb-0"><span class="greyOscuro"><strong>$ {{pago.monto}}</strong></span></h5>
											<p class="mb-3"><small class="greyColor" style="font-size: 12.8px">Monto</small></p>
										</div>
										<div class="mb-2" v-if="pago && pago.descuentos && pago.descuentos.monto">
											<p class="mb-0 mt-2 greyOscuro" style="font-size: 16px !important"><strong>{{pago.descuentos.monto}}</strong></p>
											<small class="greyColor">Descuento</small>
										</div>
										<div v-if="pago.descuento">
											<p class="mb-0 greyOscuro"><span>{{pago.descuento}}</span></p>
											<small class="greyColor">Concepto de descuento</small>
										</div>
									</vs-col>
								</vs-row>
							</vs-col>
						</vs-row>
					</vs-col>
				</vs-row>
				<vs-col>
					<div class="mb-2 text-right" v-if="descuentoPrice > 0">
						<p class="mb-0 mt-3 greyOscuro" style="font-size: 16px !important"><strong>{{descuentoPrice}}</strong></p>
						<small class="greyColor">Descuento</small>
						<h4 class="mb-0 text-right"><span class="greyOscuro"><strong>$ {{subtotal}}</strong></span></h4>
						<p class="mb-3 mt-2 text-right"><small class="greyColor" style="font-size: 12.8px">Total</small></p>
					</div>
					<div v-else>
						<h4 class="mb-0 text-right"><span class="greyOscuro"><strong>$ {{subtotal}}</strong></span></h4>
						<p class="mb-3 text-right"><small class="greyColor" style="font-size: 12.8px">Total</small></p>
					</div>
				</vs-col>
				<vs-button block class="color-blue" @click="aplicarPagos">
					Guardar  
				</vs-button> 
			</div>
		</template>	
	</vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor'
export default {
	props:[
	'value',
	'row',
	'personaId',
	'cicloEscolar',
	'cicloEscolares',
	'institucion',
	'tipo',
	'nivel',
	'nivelId',
	'listNivel',
	'programa',
	'programaId',
	'programas',

	],
	data () {
		return {
			active: false,
			descuento: false,
			conceptoDescuento: '',
			fecha: null,
			monto: null,
			montoDescuento: null,
			comentarios: null,
			autorizacion: null,
			metodoPagoId: (new Date()).getTime(),
			conceptoId: (new Date()).getTime(),
			conceptoDescuentoId: (new Date()).getTime(),
			metodoPago: '',
			concepto: '',
			listMetodoPago :[],
			listConceptos: [],
			noConceptos : false,
			listDescuento: [],
			errorFields: [],
			queuePagos:[],
			metodosPago: [],
			subtotal: '',
			total: '',
			descuentoPrice: '',
			bloquear: false,
			loadingConcepto: false,
			conceptoName: '',
			isOptionSeleted: false,
			isDropdownOpen: false,
			searchTerm: '',
			selectedOption: '',
		}
	},
	computed: {
		filteredOptions() {
		if (!this.searchTerm) return this.listConceptos;
			return this.listConceptos.filter(option =>
				option.nombre.toLowerCase().includes(this.searchTerm.toLowerCase())
			);
		},
	},
	methods: {
		showSearch() {
			this.isDropdownOpen = true;
			this.$nextTick(function (){
				this.$refs.searchConceptos.focus();
			})
		},
		toggleDropdown() {
			this.isDropdownOpen = !this.isDropdownOpen;
		},
		selectOption(option) {
			this.isOptionSeleted = true
			const sub = option.subcategoria_servicio ? option.subcategoria_servicio : ''
			const abierto = this.tipo != 'abierto' ? ' - $' + option.monto_cargo : ''
			this.conceptoName = option.nombre + abierto + sub
			this.concepto = option.id
			this.searchTerm = ''; // Limpiar el campo de búsqueda después de seleccionar una opción
			this.$nextTick(function (){
				this.isOptionSeleted = false
				this.isDropdownOpen = false; // Cierra el dropdown al seleccionar una opción
			})
		},
		ocultarDiv(){
			setTimeout(() => {
			if(!this.isOptionSeleted){
				this.isDropdownOpen = false;
			}
			}, 500);
		},
        async getProgramas () {
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion_id: this.institucion,
                persona_id: this.personaId,
                ciclo_escolar_id: this.cicloEscolar,
            }
            const { data: response } = await profesor.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.programas = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                }
            }
        },
		getSuma (dato){
			const vm = this
			let subtotal = 0;
			let subtotalSuma = 0;
			let descuento = 0;
			dato.forEach(i => {
				subtotal = (subtotal * 100 + i.monto * 100) / 100
				descuento += i.descuentos.monto
			})
			vm.descuentoPrice = descuento
			vm.subtotal = subtotal
		},
		async roundDecimals (e, decimals = 2) {
			this[e] = parseFloat(parseFloat(this[e]).toFixed(decimals))
		},
		async encolarPagos() {
			this.errorFields = this.sanityForm(this.tipo)
			const vm = this
			if (!this.errorFields.length) {
				if(this.autorizacion !== ''){
					this.bloquear = true
				}
				let data = {
					fecha: this.fecha,
					descuento: this.descuentoSelect,
					num_autorizacion: this.autorizacion,
					persona: this.personaId, 
					ciclo_escolar : this.cicloEscolar, 
					institucion : this.institucion,
					nivel_academico: this.nivel,
					programa: this.programa,
					monto: this.monto,
					facturar: true
				}
				if(this.tipo !== 'cargo-abono') {
					data.monto = this.monto
				}
				const metodo = this.listMetodoPago.find(e => e.id == this.metodoPago)
				if (metodo){
					data.metodo_pago_name =  metodo.text
					data.metodo_pago = metodo.id
				}
				if (this.descuento && this.tipo === 'abierto') {
					const descuento = this.listDescuento.find(e => e.id == this.conceptoDescuento)
					if (descuento) {
						data.descuento = descuento.nombre
						data.descuentos = {
							monto : this.montoDescuento,
							codigo_detalle : this.conceptoDescuento   
						}
					}
				}else{
					data.descuento = ''
					data.descuentos = {
						monto : 0   
					}
				}
				const concepto = this.listConceptos.find(e => e.id == this.concepto)
				if (concepto){
					data.codigo_detalle_name = concepto.nombre
					data.codigo_detalle = concepto.id
					data.subcategoria = concepto.subcategoria_servicio
				}
				if (this.tipo != 'abierto' && concepto){
					data.regla_cobro = concepto.regla
				/// Este código es para el flujo donde si seleccionaban una insc 3 se les asignaba la INSc2 y 1 en auto	
                // const oldConcepts = this.listConceptos
                //   .filter( e => {
                //     if (vm.tipo === 'servicio' ) {
                //       return e.obligatorio && new Date(e.fecha) < new Date(concepto.fecha) 
                //     } else {
                //       return new Date(e.fecha) < new Date(concepto.fecha)
                //     }
                //   })
                // if (oldConcepts.length){
                //   oldConcepts.forEach(e => {
                //     this.queuePagos.push({
                //       ...data, 
                //       monto: e.monto_cargo,
                //       codigo_detalle_name: e.nombre,
                //       codigo_detalle: e.id,
                //       regla_cobro: e.regla
                //     })
                //   })
                // }
            }
            this.queuePagos.push(data)
			this.getSuma(this.queuePagos)

            // this.fecha = null
            this.monto = null
            // this.autorizacion = null
            // this.metodoPago = ''
           
            this.concepto = '' 
			this.conceptoName = ''
            this.errorFields = []
            if (this.descuento && this.tipo === 'abierto'){
            	this.conceptoDescuento = '' 
            	this.montoDescuento = null
            }
			this.descuento = false

              // this.active = false
          }        
      },
      openLoading() {
      	const loading = this.$vs.loading({
      		target: this.$refs.content,
      	})
      	setTimeout(() => {
      		loading.close()
      	}, 3000)
      },
      async aplicarPagos() {
		this.autorizacion = ''
		this.bloquear = false
		const vm = this
      	vm.loading = vm.$vs.loading()
      	const base = {tipo: this.tipo };
      	const payload = Object.assign(base, {"pagos": this.queuePagos});	

      	try {
      		const { data: response = null } = await profesor.registrarPago(payload) || {}
      		vm.loading.close()
			this.borrarInfo()
      		if (response && response.errores){
      			const data = response.errores
				let mensajes = Object.values(data)
				if (Array.isArray(mensajes)){
					mensajes.forEach(element => {
						if ( this.checkByType('string', element)){
							this.$vs.notification({
              					icon: '<i class="fas fa-exclamation-circle"></i>',
              					width: '100%',
								duration: 'none',
								color: 'danger',
								position: null,
								title: 'Error',
								text: element 
							})
						}
					});
				}else if (mensaje.descripcion && this.checkByType('string', mensaje)){
					this.$vs.notification({
							icon: '<i class="fas fa-exclamation-circle"></i>',
							width: '100%',
							duration: 'none',
							color: 'danger',
							position: null,
							title: 'Error',
							text: mensaje.descripcion 
					})
					
				}else {
					this.$vs.notification({
						duration: 'none',
						color: 'warn',
						position: null,
						title: 'Warning',
						text: `Algo salió mal pero es posible que se haya registrado tu pago`
					})
				}

      		}else if (response && response.status && response.status == 200){
				  	this.borrarInfo()
				  	vm.loading.close()
      				const data = response.descripcion	
      				this.$vs.notification({
      					duration: 'none',
      					color: 'success',
      					position: null,
      					title: 'Éxito',
      					text: data
      				})

      		}else{
      			vm.loading.close()
      			this.$vs.notification({
      				progress: 'auto',
      				duration: 5000,
      				color: 'warn',
      				position: null,
      				title: 'Warning',
      				text: `Algo salió mal pero es posible que se haya registrado tu pago`
      			})
      		}
      		this.queuePagos = []

      		await new Promise(r => setTimeout(r, 100))
      		this.$emit('refreshTable',true)
      		this.active = false
      	} catch (error) {
			vm.loading.close()
			const response = error.response.data
      		if (response && response.errores){
      			const data = response.errores
				let mensajes = Object.values(data)
      			mensajes.forEach(element => {
					if (! this.checkByType('number', element)){
						this.$vs.notification({
							icon: '<i class="fas fa-exclamation-circle"></i>',
							width: '100%',
							duration: 'none',
							progress: 'auto',
							color: 'danger',
							position: null,
							title: 'Error',
							text: element 
						})
					}
      			});

      		}else{
      			this.$vs.notification({
					icon: '<i class="far fa-times-circle"></i>',
					width: '100%',
      				duration: 'none',
      				color: 'danger',
      				position: null,
      				title: 'Error',
      				text: `Algo salió mal`
      			})
      		}
			this.queuePagos = []

      		await new Promise(r => setTimeout(r, 100))

      		this.$emit('refreshTable',true)
      		this.active = false
			this.borrarInfo()
      	}      
      },
	  borrarInfo(){
      	this.descuento = false
		this.autorizacion = ''
      	this.fecha = ''
      	this.monto = ''
      	this.metodoPago = ''
      	this.concepto = ''
		this.conceptoName = ''
		this.listConceptos = []
		this.conceptoDescuento = ''
      	this.montoDescuento = null
		this.queuePagos = []
		this.bloquear = false
	  },
      removerPago(index) {
      	this.queuePagos.splice(index, 1);
      },
      checkByType (type, val) {
      	switch (type) {
      		case 'string':
      		if (val && val.constructor.name === 'String' && val.trim()) {
      			return true
      		}
      		case 'number':
      		if (val && val.constructor.name === 'Number' && val > 0) {
      			return true
      		} 
      		case 'date':
      		if (val && val.constructor.name === 'String' && val.trim()) {
      			const date = new Date(val)
      			if (Object.prototype.toString.call(date) === "[object Date]"){
      				if (!isNaN(date.getTime())){
      					return true
      				}
      			}
      		}
      		case 'array':
      		if (Array.isArray(val) && val.length){
      			return true
      		}
      	}
      	return false
      },
      sanityForm () {
      	let errorFields = []

      	if (!this.checkByType ('date', this.fecha)) {
      		errorFields.push('fecha')
      	}
      	if (!this.checkByType ('string', this.autorizacion)) {
      		errorFields.push('autorizacion')
      	}
      	if (!this.monto) {
      		errorFields.push('monto')
      	}
      	if (!this.checkByType ('number', this.concepto)) {
      		errorFields.push('concepto')
      	}
      	if (!this.checkByType ('string', this.metodoPago)) {
      		errorFields.push('metodoPago')
      	}
      	if (this.descuento && this.tipo === 'abierto') {
      		if (!this.checkByType ('number', this.conceptoDescuento)) {
      			errorFields.push('conceptoDescuento')
      		}
      	}
      	if (!this.checkByType ('number', this.programa)) {
      		errorFields.push('programa')
      	}  
      	
      	return errorFields
      },
      async initCatalogs() {
      	if (!this.listMetodoPago.length){
      		try {
      			const { data: metodos } = await profesor.getMetodosPagos()
      			if (Array.isArray(metodos)){
      				this.listMetodoPago = metodos
      				this.metodoPagoId = (new Date()).getTime()
      			}
      		} catch (error) {
      			console.log(error)
      		}
      	}
      	if (!this.listDescuento.length){
      		try {
      			const { data: descuentos } = await profesor.getDescuentos()
      			if (Array.isArray(descuentos)){
      				this.listDescuento = descuentos
      				this.conceptoDescuentoId = (new Date()).getTime()
      			}
      		} catch (error) {
      			console.log(error)
      		}
      	}
      	
      	
      	await this.getConcepto()
      },
      async getConcepto() {
		if(this.fecha){
			this.loadingConcepto = true
			const vm = this
			if(this.tipo !== 'cargo-abono'){
				if(this.programa !== '' && this.cicloEscolar !== '' && this.tipo !== ''){
					let params = {
						programa : this.programa,
						institucion: this.institucion,
						ciclo_escolar: this.cicloEscolar,
						tipo: this.tipo,
						persona: this.personaId,
					}
					const {data: response} = await profesor.getConceptosRegistrarPago(params) || {}
					this.concepto = ''
					this.conceptoName = ''
            		const filtrados = response.filter(concepto => this.filtrarConcepto(concepto))
					this.listConceptos = filtrados

					if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
						this.noConceptos = false
						setTimeout(function() {
								vm.loadingConcepto = false
						}, 3000); 
					}else {
						this.noConceptos = true
						this.loadingConcepto = false
					}
				}
			} else if(this.tipo === 'cargo-abono'){
				if(this.programa !== '' && this.cicloEscolar !== '' && this.tipo !== ''){
					let params = {
						programa : this.programa,
						institucion: this.institucion,
						ciclo_escolar: this.cicloEscolar,
						tipo: 'cargo-abono',
						persona: this.personaId,
						fecha: this.fecha
					}
					const {data: response} = await profesor.getConceptos(params) || {}
					this.listConceptos = response
					this.concepto = ''
					this.conceptoName = ''
					this.monto = ''

					if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
						this.noConceptos = false
						setTimeout(function() {
								vm.loadingConcepto = false
						}, 3000); 
					}else {
						this.noConceptos = true
						this.loadingConcepto = false
					}
				}

			}
			this.conceptoId = (new Date()).getTime()
		}
      },
	  filtrarConcepto(concepto){
		if(concepto.nombre !=  'PAGO MATERIAL DE SERVICIOS EDUCATIVOS' && concepto.nombre !=  'PAGO FIDEICOMISO' && concepto.nombre !=  'PAGO ACTIVIDAD DEPORTIVA' && concepto.nombre !=  'PAGO ACTIVIDAD ARTISTICA' && concepto.nombre !=  'PAGO ACTIVIDAD PASTORAL' && concepto.nombre !=  'PAGO ACTIVIDAD ACADEMICA' && concepto.nombre !=  'PAGO SERVICIOS ESCOLARES' && concepto.nombre !=  'PAGO OTROS'){
			return true
		}
		return false
	  },
      getMonto() {
      	if(this.tipo !== 'abierto' ){
      		const monto = this.listConceptos
      		monto.forEach(i => {
      			if(i.id === this.concepto){
      				this.monto = i.monto_cargo
      			}
      		})
      	}
      }
  },
  watch: {
	async programa(){
		this.programa = this.programaDefault
	},
  	async programa(val){
  		await this.getConcepto()
  	},
  	value (val) {
  		this.active = val
  	},
  	concepto(val){
  		if (this.tipo !== 'abierto') {
              
              this.getMonto()
          }
    },
      async active (val) {
      	await this.initCatalogs()
      	if (!val){
      		this.$emit('input', val);
      	}
      },
      async tipo (val) {
      	this.descuento = false
      	this.fecha = ''
      	this.monto = ''
      	this.montoDescuento = null
      	this.metodoPago = ''
      	this.concepto = ''
		this.conceptoName = ''
      	this.queuePagos = []
      	this.errorFields = []
      	this.listConceptos = []
		this.autorizacion = ''
		this.conceptoDescuento = ''
      },
  }
}
</script>

<style lang="scss"  scoped >
$breakpoint-tablet: 767px;
.color-blue {
	background-color: #005aa3;
}

.dividerLine {
	width: 100%;
	border-bottom: 1px solid #ddd
}

.greyColor {
	color: gray
}

.greyOscuro {
	color: rgb(78, 78, 78);
	font-weight: bold;
}

.marginTop{
	@media only screen and (max-width: $breakpoint-tablet) {
		margin-top: 1rem;
	}
}

.textRight{
	@media only screen and (max-width: $breakpoint-tablet) {
		text-align: right;
	}
	@media only screen and (min-width: $breakpoint-tablet) {
		text-align: center;
	}
}
.textRightDesktop{
	@media only screen and (min-width: $breakpoint-tablet) {
		text-align: right;
	}
}

.custom-select {
  width: 100%;
}


.styled-select{
	width: 100%;
	opacity: 1;
	padding: 7px 13px;
	border-radius: 12px;
	cursor: pointer;
	background: transparent;
	border: 2px solid transparent;
	background: rgba(244, 247, 248, 1);
	color: rgba(44, 62, 80, 1);
	min-height: 38px;
	padding-right: 30px;
}
/* Quitar borde en estado focus (cuando está seleccionado) */
.styled-select:focus {
  border: none;
  outline: none;
  box-shadow: none;
}

/* Quitar borde en estado active (cuando se selecciona una opción) */
.styled-select:active {
  border: none;
  outline: none;
  box-shadow: none;
}

.styled-select option{
	background: #ffff;
}

.native-select:hover {
  background-color: #c02c2c;
}

// ----------

.custom-input {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-input {
  width: 100%;
  padding: 8px;
  border: none; /* Sin borde para el input de búsqueda */
  outline: none; /* Sin contorno al hacer clic */
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  z-index: 9;
}

.options {
  max-height: 150px; /* Altura máxima para la caja de opciones */
  overflow-y: auto; /* Permite el desplazamiento vertical si hay muchas opciones */
}

.option {
  padding: 8px;
  cursor: pointer;
}

.option:hover {
  background-color: #f0f0f0;
}

.margenShadow{
	-webkit-box-shadow: 0px 10px 20px -5px rgba(235,235,235,0.5);
	-moz-box-shadow: 0px 10px 20px -5px rgba(235,235,235,0.5);
	box-shadow: 0px 10px 20px -5px rgba(235,235,235,0.5);
	border-radius: 12px;
}
.spinner-overlay {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 0, 0, 0.07);
  border-radius: 50%;
  border-top-color: #177bbd; /* Color del spinner */
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style>
.labelInput{
	margin-bottom: 6px !important;
	padding: 0px 11px 0px 11px;
	font-size: 12px;
}

.dangerColor{
	color: red;
	font-size: 18px;
}
</style>